import type DateAnswerModel from '../../../models/DateAnswerModel';
import { requestAndParse, requestSuccessful } from '../request';

const getDateAnswers = async (studyId?: number, participantId?: string) => {
    const route = 'admin/get-date-answers';
    const payload = { studyId, participantId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const answers = (response.body?.answers ?? []) as DateAnswerModel[];
    const columns = (response.body?.columns ?? []) as string[];

    return { success, answers, columns };
};

export default getDateAnswers;
